import React, {Fragment, useEffect, useState} from 'react';
import Strings from "../../assets/strings";

import {Button, Dialog, DialogActions, Grid, InputAdornment, TextField, Theme, useMediaQuery} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import {buildAmort, formatDate, getUsuTipo, object2queryParams, TIPOUSUARIO} from '../../helpers';
import TopBarDialog from "../topBar/TopBarDialog";
import {SelectEnum} from "../selects";
import {DateInput, TextFieldCurrency} from "../CustomTextField";
import {calAmortizacion, calcularTasa} from "../../services";
import {HtmlTooltip} from "../index";
import AmortList from "./AmortList";
import {IAmortizacion} from "../../redux/types/IPrestamo";
import {MODAL_EXPORT_TYPE} from "../../views/prestamos/ContratoDialog";
import {useLocation, useNavigate} from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import LoadingProgress from "../LoadingProgress";
import {CICLOS_PAGO, getValueString} from "../../helpers/CONSTANTES";

const useStyles = makeStyles((theme:Theme) => ({
  root: {
    flexGrow: 1,
  },
  inputCont:{
    padding: "12px 16px",
    "& .MuiInput-input":{
      padding: ".25rem .5rem !important",
      [theme.breakpoints.down('md')]: {
        padding: ".25rem 0",
      }
    }
  },
  inputDataCont:{
    paddingBottom: theme.spacing(1),
  },
  btn:{
    marginRight: 5,
    color:theme.palette.common.white,
    fontWeight:"normal",
  }
}));

interface IData {
  fechaPrimerPago?: string,
  monto?: number,
  tasa?: number,
  cuotas?: number,
  cicloPago?:number,
  tipoAmortizacion?:number,
  montoCuota?:number,
  montoSeguro?:number,
  comision?:number,

}
const initialState:IData={
  fechaPrimerPago: formatDate(new Date(),"YYYY-MM-DD"),
  monto: 0,
  tasa: 0,
  cuotas: 0,
  cicloPago:30,
  tipoAmortizacion:1,
  montoCuota:0,
  montoSeguro: 0,
  comision: 0,
}


type Props = {
  onClose?:any
  onUseVal?:any
  inicialState?:IData
}
export default function AmortCal({onClose,onUseVal,inicialState:inicialStateProp}:Props){
  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  const classes = useStyles();
  let navigate = useNavigate();
  let {pathname, state:urlState} = useLocation();

  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [list, setList] = useState<IAmortizacion[]>([]);
  const [state, setState] = useState(inicialStateProp?inicialStateProp:initialState);


  // Reset fecha si se cambia a modalidad quincenalFijo
  const {cicloPago} = state
  useEffect(()=>{
    if(cicloPago === 16) setState(prevState => ({...prevState, cicloPago, fechaPrimerPago: ""}));
  },[cicloPago]);

  const calcular = (e:React.FormEvent<HTMLFormElement>)=>{
    e.preventDefault();
    setLoading(true);
    calAmortizacion(state).then(res=>{
      setState(prev=>({...prev, tasa: res.data[0]?.interesPorciento}))
      setList(res.data)
    }).finally(()=>setLoading(false))
    // getAmortList(state).then((res)=> {
    //   setState(prevState => ({...prevState,tasa: res.tasa}))
    //   setList(res.list)
    // })
  }
  const handleChange =  (e:React.ChangeEvent<HTMLInputElement>) => {
    const {value,name} = e.target
    if(name === "cuotas" && parseInt(value) > 800) return false;
    setState({...state,[name]:value});
  };

  const formId = Math.random().toString();
  return (
      <Fragment>

        <Dialog
          open={true}
          onClose={onClose}
          fullScreen={smVewport}
          maxWidth={"sm"}
          fullWidth
        >
          <TopBarDialog title={Strings.calculadora} onClose={onClose}>
            {!!list.length &&
            <Button className={classes.btn} size={"small"}
                        // onClick={()=>downloadFiles({
                        //   Monto:state.monto,
                        //   TipoAmortizacion:state.tipoAmortizacion,
                        //   CicloPago: state.cicloPago,
                        //   Tasa:state.tasa,
                        //   Cuotas:state.cuotas,
                        //   FechaPrimerPago:state.fechaPrimerPago
                        // },"rptAmortizacion")}

                    onClick={()=> navigate(pathname+object2queryParams(state), {state:{...urlState, modalExport:{id: 1, type: MODAL_EXPORT_TYPE.AMORTIZACION}}})}

                // onClick={()=>openNewWin("/reports/amortizacion",state)}
            >
              {Strings.exportar}
            </Button>
            }
          </TopBarDialog>
          {loading && <LoadingProgress />}
            <form onSubmit={calcular} id={formId} className={classes.inputCont}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextFieldCurrency
                      name="monto"
                      required
                      value={state.monto}
                      onChange={handleChange}
                      fullWidth
                      label={"Monto del Préstamo"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <SelectEnum
                      required
                      label={Strings.modalidad+" de Pago"}
                      group="ciclosPago"
                      name= 'cicloPago'
                      value={state.cicloPago}
                      onChange={handleChange}
                  />

                </Grid>
                <Grid item xs={4}>
                  <TextField
                      name="cuotas"
                      required
                      value={state.cuotas}
                      onChange={handleChange}
                      type="number"
                      inputProps={{step:1,inputMode:"numeric"}}
                      fullWidth
                      label={"# "+Strings.cuotas}
                      margin={"none"}
                      size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                      name="tasa"
                      required={!state.montoCuota}
                      value={state.tasa}
                      onChange={handleChange}
                      type="number"
                      inputProps={{step:"any",inputMode:"decimal", max:100}}
                      fullWidth
                      disabled={(state.montoCuota??0)>0}
                      label={Strings.interes+" "+(!!state.cicloPago && getValueString(CICLOS_PAGO, +state.cicloPago)) }
                      InputProps={{
                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                      }}
                      margin={"none"}
                      size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <SelectEnum
                      label={"Tipo de "+Strings.amortizacion}
                      required
                      group="tiposAmortizacion"
                      name='tipoAmortizacion'
                      value={state.tipoAmortizacion}
                      onChange={handleChange}
                  />
                </Grid>

              </Grid>
              <Collapse in={!!showMore}>
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <HtmlTooltip title={
                      <em> {Strings.interesDesconocidoMsj}</em>
                    } disableHoverListener>
                      <div>
                        <TextFieldCurrency
                            name="montoCuota"
                            value={state.montoCuota}
                            onChange={handleChange}
                            fullWidth
                            disabled={!state.tipoAmortizacion}
                            placeholder={"Opcional"}
                            label={Strings.monto+" de "+Strings.cuotas}
                        />
                      </div>
                    </HtmlTooltip>
                  </Grid>
                  <Grid item xs={6}>
                    <DateInput
                        name="fechaPrimerPago"
                        value={state.fechaPrimerPago}
                        label={Strings.primerPago}
                        fullWidth
                        margin={"none"}
                        quincenalFijo={state.cicloPago === 16}
                        onChange={handleChange} native={undefined} clearable={undefined} openTo={undefined}
                        views={undefined}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextFieldCurrency
                        name="montoSeguro"
                        value={state.montoSeguro}
                        onChange={handleChange}
                        fullWidth
                        placeholder={"Opcional"}
                        label={"Monto de Seguro"}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                        name="comision"
                        value={state.comision}
                        onChange={handleChange}
                        inputProps={{step:1,inputMode:"numeric"}}
                        type="number"
                        fullWidth
                        label={"% Comisión"}
                        margin={"none"}
                        size="small"
                    />
                  </Grid>
                </Grid>
              </Collapse>
            </form>
            <Button size={"small"}
                    color={"inherit"}
                    sx={{
                      textTransform: "none",
                      width: 150,
                      m:"0 auto",
                      mt:-1,
                      mb:1,
                      color:!!list.length?"#a1a1a1":"inherit"
                    }}
                    onClick={()=>setShowMore(!showMore)}>Mostrar {!showMore?"Más":"Menos"}...</Button>



            <AmortList list={list}/>
          <DialogActions>
            {onUseVal &&
              <Button type={"button"} onClick={()=>{onClose(); onUseVal(state)}} color="primary" sx={{marginRight: "auto"}}>
                {Strings.usar} {Strings.valores}
              </Button>
            }

            <Button type="submit" form={formId} color="primary"  variant={"outlined"}>
              {Strings.calcular}
            </Button>

          </DialogActions>
        </Dialog>
      </Fragment>
    );

}

export async function getAmortList ({monto,tasa:stInteres,cuotas,cicloPago,tipoAmortizacion,fechaPrimerPago,montoCuota}:{monto?:number,tasa?:number,cuotas?:number,cicloPago?:number,tipoAmortizacion?:number,fechaPrimerPago?:string,montoCuota?:number}){
  let tasa:number = stInteres??0;
  if(montoCuota && monto && cuotas && tipoAmortizacion ){
    switch (tipoAmortizacion?.toString()) {
      case "1":
       await calcularTasa({
            montoCuota: montoCuota ?? 0,
            plazo: +(cuotas ?? 0),
            capital: +(monto ?? 0),
            tipoAmortizacion: +(tipoAmortizacion ?? 0)
          }).then(({data})=> tasa=data)
        break
        //value*(  (1-Math.pow(1 + i,-5) )/ 0.1)
      case "2": //disminuir cuota
        tasa = (montoCuota-monto/cuotas)/monto*100
        break
      case "3": //tasa fijo -- //mismo resultado de arriba ;)
        tasa = (1 / cuotas) * (montoCuota * cuotas / monto - 1) * 100;
        break
      case "4": //monto al final
        tasa = (montoCuota * 100) / monto;
        break
      default: //capital al final
        tasa = 0
    }
    //setState({...state,tasa})
  }


  if(monto && !isNaN(tasa) && cuotas){
    return {
      tasa,
      list:buildAmort(monto, tasa, cuotas, cicloPago, tipoAmortizacion, fechaPrimerPago) as IAmortizacion[]
    };
  }
  return {tasa,list:[] as IAmortizacion[]};
}
